import {
  AlternateOwnership,
  HouseType,
  RentalOrUnoccupied,
  RoofType,
} from "./houseTypes";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";

export interface HouseProductIntroFormValues
  extends AddressInfoFormValues,
    Partial<HouseProductHouseSearchFormValues> {}

export interface AddressInfoFormValues {
  addressSameAsHomeAddress?: BooleanFormType;
  postNumber?: string;
  validPostNumber?: boolean;
  city?: string;
  recentlyBought?: BooleanFormType;
}

export interface HouseProductInfoDetailsFormValues {
  houseType: HouseType;
  constructionYear: string;
  boa: number;
  bta: number;
  saved: boolean;
  otherBuildings: AdditionalBuildingFormValues[];
}

export interface AdditionalBuildingFormValues {
  type: AdditionalBuildingFormType;
  areal: number;
  constructionYear: string;
  id: string;
  isNew?: boolean;
  saved: boolean;
}

export enum AdditionalBuildingFormType {
  GARAGE_ISOLATED = "GARAGE_ISOLATED",
  GARAGE_NON_ISOLATED = "GARAGE_NON_ISOLATED",
  CARPORT = "CARPORT",
  OUTHOUSE_ISOLATED = "OUTHOUSE_ISOLATED",
  OUTHOUSE_NON_ISOLATED = "OUTHOUSE_NON_ISOLATED",
  GARAGE_OUTHOUSE_ANNEX = "GARAGE_OUTHOUSE_ANNEX",
}

export interface HouseProductHouseSearchFormValues {
  ownsSearchedHouse?: boolean;
  ownedEstate?: string;
  selectedAddress?: string;
  addressSearch?: string;
  alternateOwnership?: AlternateOwnership;
  address: string;
  cadastralGnr: number;
  cadastralBnr: number;
  cadastralKnr: number;
  cadastralFnr: number;
  cadastralSnr: number;
  roofType?: RoofType;
  hasBasementRoom?: boolean;
  hasFloodRisk?: boolean;
  realEstateInfo: RealEstateInfo;
}

export interface RealEstateInfo {
  grossArea?: number;
  livingFloorSpace?: number;
  constructionYear?: number;
  houseType?: HouseType;
  postNumber?: number;
  city?: string;
  otherBuildings?: AdditionalBuildingFormValues[];
}

export interface HouseProductDetailsFormValues
  extends RentalFormValues,
    InjuriesFormValues {
  historicalValue?: BooleanFormType;
  hasBasementRoom?: BooleanFormType;
  isRoofChanged?: BooleanFormType;
  isWetAreasRehabilitatedOrChanged?: BooleanFormType;
  isWithHistoryOfWaterOrMoistureDamage?: BooleanFormType;
  pestsDamaged?: BooleanFormType;
  maintenanceConfirmation: BooleanFormType;
  hasFireAlarm: boolean;
  hasBurglarAlarm: boolean;
  hasCircuitBreakers?: boolean;
  hasPipeInPipeSystem?: boolean;
  hasWaterGuard: boolean;
}

export interface RentalFormValues {
  rentalOrUnoccupied: RentalOrUnoccupied;
  validNumberOfRentalUnits?: BooleanFormType;
  validNumberOfInhabitants?: BooleanFormType;
}

export interface HousePriceFormValues {
  deductible: string;
  coverage: InsuranceCoverage;
  buyHouseContentsInsurance: BooleanFormType;
  injuries?: string;
  injuryYear?: string;
  contentsDeductible?: string;
  contentsInsuranceSum?: number;
  contentsCoverage?: InsuranceCoverage;
  fireResistantBuildingMaterial?: BooleanFormType;
  onlyFireAndNatureDamage?: boolean;
  fullRental?: boolean;
}
